import { IDatasetTypeMetadata, IDynamicDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';
import { sqlServerDatasetMetadata } from 'app/registries/dataset/sqlserver-metadata';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

import {
    getSqlParallelReadMetadataConsts,
    isolationLevelMetadata,
    queryTimeoutMetadata
} from 'app/registries/consts/metadata-consts';

export const amazonRdsSqlServerDatasetMetadata: IDynamicDatasetTypeMetadata = async (injector) => {
    const baseMetadata = _.cloneDeep(sqlServerDatasetMetadata);
    const metadata: IDatasetTypeMetadata = {
        ...baseMetadata,
        type: adfModelTypeMap.amazonRdsSqlServer.datasetType,
        supportLinkedServiceTypes: [adfModelTypeMap.amazonRdsSqlServer.linkedServiceType],
        displayName: stringResources.AmazonRdsSqlServer_DisplayText,
        supportEditPhysicalType: false, // override config that inherited from sql server
        isSink: false,
        icon: {
            className: 'svg-i-100x100-aws_redshift'
        },
        copySourceControls: [
            queryTimeoutMetadata,
            isolationLevelMetadata,
            getSqlParallelReadMetadataConsts(adfModelTypeMap.amazonRdsSqlServer.copySourceType)
        ],
        copySinkControls: undefined,
        copySinkPropertiesRequireParameters: undefined,
        supportDataFlowSource: false,
        supportDataFlowSink: false,
        copyJob: {
            multipleQuery: true,
            sourcePartition: {
                supportSourcePartition: true
            }
        }
    }
    return metadata;
}
